import { Navigate, type RouteObject } from "react-router";
import { AppLayout } from "./AppLayout.tsx";
import { AppShell } from "./AppShell.tsx";
import { ClaimPage } from "../pages/claim/ClaimPage.tsx";
import { ComposeSheet } from "../pages/compose/ComposeSheet.tsx";
import { EditNameSheet } from "../pages/profile/EditNameSheet.tsx";
import { EvaPage } from "../pages/eva/EvaPage.tsx";
import { GuestOnly, RequireSession } from "./guards.tsx";
import { HistorySheet } from "../pages/home/HistorySheet.tsx";
import { HomePage } from "../pages/home/HomePage.tsx";
import { InvitePage } from "../pages/invite/InvitePage.tsx";
import { LegalPage } from "../pages/legal/LegalPage.tsx";
import { LoginPage } from "../pages/login/LoginPage.tsx";
import { MessageDetailsSheet } from "../pages/home/MessageDetailsSheet.tsx";
import { NotFoundPage } from "../pages/NotFoundPage.tsx";
import { ProfilePage } from "../pages/profile/ProfilePage.tsx";
import { RegisterPage } from "../pages/register/RegisterPage.tsx";
import { ScanSheet } from "../pages/claim/ScanSheet.tsx";
import { StartPage } from "../pages/start/StartPage.tsx";

export const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        element: <GuestOnly />,
        children: [
          { index: true, element: <StartPage /> },
          { path: "login", element: <LoginPage /> },
          { path: "register", element: <RegisterPage /> },
        ],
      },
      {
        element: <RequireSession />,
        children: [
          {
            element: <AppShell />,
            children: [
              {
                // Главная — layout: шторки поверх неё вложенными маршрутами, без перемонтирования главной.
                element: <HomePage />,
                children: [
                  // Сама главная, без шторки. `element: null` явно: лист без element React Router считает ошибкой.
                  { path: "feed", element: null },
                  { path: "claim/scan", element: <ScanSheet /> },
                  { path: "messages/:messageId", element: <MessageDetailsSheet closeTo="/feed" /> },
                  {
                    // Детали из истории — поверх неё: «назад» возвращает в историю с тем же фильтром и прокруткой.
                    path: "history",
                    element: <HistorySheet />,
                    children: [
                      { path: "messages/:messageId", element: <MessageDetailsSheet closeTo="/history" /> },
                    ],
                  },
                  { path: "compose", element: <ComposeSheet /> },
                  { path: "drafts", element: <Navigate to="/feed" replace /> },
                ],
              },
              { path: "eva", element: <EvaPage /> },
              {
                // Профиль — layout: «Изменить» открывается шторкой поверх него, «назад» её закрывает.
                path: "profile",
                element: <ProfilePage />,
                children: [{ path: "edit", element: <EditNameSheet /> }],
              },
            ],
          },
          // Ссылка из QR на экране E-va (ADR-005); без сессии — вход и возврат сюда.
          { path: "claim", element: <ClaimPage /> },
          // Invite-ссылка от владельца E-va; без сессии — вход и возврат сюда.
          { path: "invite/:token", element: <InvitePage /> },
        ],
      },
      // Ссылки из формы регистрации: доступны и без сессии, и с ней.
      { path: "terms", element: <LegalPage title="Пользовательское соглашение" /> },
      { path: "privacy", element: <LegalPage title="Политика конфиденциальности" /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];
